import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-messages-tab',
  templateUrl: './messages-tab.component.html',
  styleUrls: ['./messages-tab.component.css']
})
export class MessagesTabComponent implements OnInit {
  
  constructor() { }

  ngOnInit() {
   
  }
  

}
